export const ROUTER_DETAILS = {
    "VMware edge510": {
        "size": "Small",
        "material_number": 908136,
        "mat_name": "SD WAN Router S",
        "price_non_german": 21.07,
        "price_german": 25.08,
        "eol": false
    },
    "VMware edge510-lte": {
        "size": "Small",
        "material_number": 908136,
        "mat_name": "SD WAN Router S",
        "price_non_german": 21.07,
        "price_german": 25.08,
        "eol": false
    },
    "VMware edge520": {
        "size": "Small",
        "material_number": 908136,
        "mat_name": "SD WAN Router S",
        "price_non_german": 21.07,
        "price_german": 25.08,
        "eol": false
    },
    "VMware edge710": {
        "size": "Small",
        "material_number": 908136,
        "mat_name": "SD WAN Router S",
        "price_non_german": 21.07,
        "price_german": 25.08,
        "eol": false
    },
    "VMware edge620": {
        "size": "Medium",
        "material_number": 908135,
        "mat_name": "SD WAN Router M",
        "price_non_german": 37.69,
        "price_german": 44.86,
        "eol": false
    },
    "VMware edge720": {
        "size": "Large",
        "material_number": 908218,
        "mat_name": "SD WAN Router L",
        "price_non_german": 50.57,
        "price_german": 60.18,
        "eol": false
    },
    "VMware edge680": {
        "size": "Large",
        "material_number": 908218,
        "mat_name": "SD WAN Router L",
        "price_non_german": 50.57,
        "price_german": 60.18,
        "eol": false
    },
    "VMware edge740": {
        "size": "Xtra Large",
        "material_number": 908137,
        "mat_name": "SD WAN Router XL",
        "price_non_german": 143.58,
        "price_german": 170.86,
        "eol": false
    },
    "VMware edge3800": {
        "size": "Xtra Large",
        "material_number": 908137,
        "mat_name": "SD WAN Router XL",
        "price_non_german": 143.58,
        "price_german": 170.86,
        "eol": false
    },
    "VMware edge3810": {
        "size": "Xtra Large",
        "material_number": 908137,
        "mat_name": "SD WAN Router XL",
        "price_non_german": 143.58,
        "price_german": 170.86,
        "eol": false
    },
    // EOL models — present at existing sites, never recommended as replacements
    "VMware edge540": {
        "size": "Medium",
        "material_number": 908135,
        "mat_name": "SD WAN Router M",
        "price_non_german": 37.69,
        "price_german": 44.86,
        "eol": true
    },
    "VMware edge640": {
        "size": "Xtra Large",
        "material_number": 908137,
        "mat_name": "SD WAN Router XL",
        "price_non_german": 143.58,
        "price_german": 170.86,
        "eol": true
    },
    "VMware edge2000": {
        "size": "Xtra Large",
        "material_number": 908137,
        "mat_name": "SD WAN Router XL",
        "price_non_german": 143.58,
        "price_german": 170.86,
        "eol": true
    },
    "VMware edge3400": {
        "size": "Xtra Large",
        "material_number": 908137,
        "mat_name": "SD WAN Router XL",
        "price_non_german": 143.58,
        "price_german": 170.86,
        "eol": true
    },
};

// Utility function to get router details
export const getRouterDetails = (routerModel) => {
    return ROUTER_DETAILS[routerModel] || { size: "unknown", material_number: "unknown", eol: false };
};
